import React, { useEffect, useState } from 'react';
import client from '../../sanity/client';
import { useLanguage } from '../../components/LanguageContext';
import './InfoPage.scss';

const InfoPage = () => {
  const [data, setData] = useState(null);
  const { language } = useLanguage();
  


  useEffect(() => {
    const fetchData = async () => {
      const query = `*[_type == "infoPage"][0]{
        title,
        photographyCredits,
        legalInfo,
        technicalCredits,
        copyright
      }`;
      
      const result = await client.fetch(query);
      setData(result);
    };

    fetchData();
  }, []);

  // Fonction helper pour récupérer le texte dans la bonne langue
  const getText = (textObj) => {
    if (!textObj) return '';
    return textObj[language] || textObj.fr || textObj.en || '';
  };

  if (!data) return <div>Loading...</div>;

  return (
    <div className="info-page">
      <div className="info-container">
        {/* Titre principal */}
        <section className="info-header">
          <h1 
            data-aos="fade-in" 
            data-aos-duration="800"
          >
            {getText(data?.title) || 'Informations'}
          </h1>
        </section>

        <div 
          data-aos="fade-in" 
          data-aos-duration="800" 
          data-aos-delay="200"
        >

        {/* Section Crédits Photographie */}
        {data?.photographyCredits && (
          <section className="info-section">
            <h2>{getText(data.photographyCredits.title)}</h2>
            {data.photographyCredits.photographers?.map((photographer, index) => (
              <div key={index} className="photographer-item">
                <h3>
                  {photographer.website ? (
                    <a 
                      href={photographer.website} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="photographer-link"
                    >
                      {photographer.name}
                    </a>
                  ) : (
                    photographer.name
                  )}
                </h3>
                {photographer.description && (
                  <p>{getText(photographer.description)}</p>
                )}
              </div>
            ))}
          </section>
        )}

        {/* Section Copyright */}
        {data?.copyright && (
          <section className="info-section">
            <h2>{getText(data.copyright.title)}</h2>
            <div className="copyright-content">
              <p className="copyright-year">
                © {data.copyright.year} {data.copyright.owner}
              </p>
              {data.copyright.content && (
                <p>{getText(data.copyright.content)}</p>
              )}
            </div>
          </section>
        )}

        {/* Section Crédits techniques */}
        {data?.technicalCredits && (
          <section className="info-section">
            <h2>{getText(data.technicalCredits.title)}</h2>
            <div className="technical-content">
              {getText(data.technicalCredits.content).split('\n').map((line, idx) => (
                <p key={idx}>{line}</p>
              ))}
            </div>
          </section>
        )}

        {/* Section Mentions légales */}
        {data?.legalInfo && (
          <section className="info-section">
            <h2>{getText(data.legalInfo.title)}</h2>
            <div className="legal-content">
              {getText(data.legalInfo.content).split('\n').map((line, idx) => (
                <p key={idx}>{line}</p>
              ))}
            </div>
          </section>
        )}
        </div>
      </div>
    </div>
  );
};

export default InfoPage;
